import { useEffect, useState } from "react";
import { MapContainer, TileLayer, useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

export const BR_CENTER = [-15.78, -47.93];
export const AREA_COLORS = ["#2563eb", "#16a34a", "#ea580c", "#9333ea", "#dc2626", "#0891b2", "#ca8a04"];

const icons = {};
export const dot = (color, size = 18) => {
  const k = `${color}${size}`;
  icons[k] ||= L.divIcon({
    className: "",
    html: `<span style="display:block;width:${size}px;height:${size}px;border-radius:50%;background:${color};border:3px solid #fff;box-shadow:0 1px 5px rgba(0,0,0,.55)"></span>`,
    iconSize: [size, size], iconAnchor: [size / 2, size / 2],
  });
  return icons[k];
};

export const numPin = (color, text) => {
  const k = `n${color}${text}`;
  icons[k] ||= L.divIcon({
    className: "",
    html: `<span style="display:flex;align-items:center;justify-content:center;min-width:30px;height:30px;padding:0 6px;border-radius:15px;background:${color};color:#fff;font:700 12px/1 monospace;border:2px solid #fff;box-shadow:0 1px 6px rgba(0,0,0,.6)">${text}</span>`,
    iconSize: [30, 30], iconAnchor: [15, 15],
  });
  return icons[k];
};

export const latlngOf = (e) => { const p = e.target.getLatLng(); return [p.lat, p.lng]; };

export function Tiles() {
  return <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' />;
}

export function MapClicks({ onClick }) {
  useMapEvents({ click: (e) => onClick([e.latlng.lat, e.latlng.lng]) });
  return null;
}

export function FlyTo({ point, zoom = 15 }) {
  const map = useMap();
  const key = point ? point.join(",") : "";
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { if (point) map.flyTo(point, zoom, { duration: 0.6 }); }, [key]);
  return null;
}

const near = (a, b) => a && b && Math.abs(a[0] - b[0]) < 1e-5 && Math.abs(a[1] - b[1]) < 1e-5;

function CenterPick({ point, onPick, setMoving }) {
  const map = useMapEvents({
    movestart: () => setMoving(true),
    moveend: () => {
      setMoving(false);
      const c = map.getCenter();
      const p = [c.lat, c.lng];
      if (!near(p, point)) onPick(p);
    },
    click: (e) => map.panTo(e.latlng),
  });
  return null;
}

function CenterPin({ moving }) {
  return (
    <div className="pointer-events-none absolute left-1/2 top-1/2 z-[500]" data-testid="customer-pin-center">
      <span className="absolute left-0 top-0 h-1.5 w-3 -translate-x-1/2 -translate-y-1/2 rounded-full bg-black/40" />
      <span className={`absolute left-0 top-0 block h-[22px] w-[22px] -translate-x-1/2 rounded-full border-[3px] border-white bg-red-600 shadow-[0_1px_5px_rgba(0,0,0,.55)] transition-transform duration-150 ${moving ? "-translate-y-[150%]" : "-translate-y-1/2"}`} />
    </div>
  );
}

export function PinMap({ point, start, focus, onPick }) {
  const [moving, setMoving] = useState(false);
  const center = point || start || BR_CENTER;
  return (
    <div className="relative isolate overflow-hidden rounded-xl border" data-testid="customer-pin-map">
      <MapContainer center={center} zoom={point || start ? 16 : 4} className="h-[320px] w-full">
        <Tiles />
        <FlyTo point={focus} zoom={17} />
        <CenterPick point={point} onPick={onPick} setMoving={setMoving} />
      </MapContainer>
      <CenterPin moving={moving} />
    </div>
  );
}
